import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onSendBulk, onMarkPaid, onDelete, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground rounded-lg shadow-2xl border border-primary/20 px-4 md:px-6 py-3 z-50 transition-smooth">
      <div className="flex items-center gap-3 md:gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} />
          <span className="font-body font-medium text-sm md:text-base whitespace-nowrap">
            {selectedCount} {selectedCount === 1 ? 'invoice' : 'invoices'} selected
          </span>
        </div>

        <div className="h-6 w-px bg-primary-foreground/20"></div>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={onSendBulk}
            iconName="Send"
            iconPosition="left"
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <span className="hidden sm:inline">Send</span>
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onMarkPaid}
            iconName="CheckCircle"
            iconPosition="left"
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <span className="hidden sm:inline">Mark Paid</span>
          </Button>

          <Button
            variant="ghost"
            size="sm"
            onClick={onDelete}
            iconName="Trash2"
            iconPosition="left"
            className="text-primary-foreground hover:bg-primary-foreground/10"
          >
            <span className="hidden sm:inline">Delete</span>
          </Button>

          <div className="h-6 w-px bg-primary-foreground/20"></div>

          <Button
            variant="ghost"
            size="icon"
            onClick={onClearSelection}
            iconName="X"
            className="text-primary-foreground hover:bg-primary-foreground/10"
            aria-label="Clear selection"
          />
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;